export class FreemiumJobDescriptionKeys {
  public job_titles: string[];
  public mandatory_job_titles: string[] | string;
  public skills: string[] | string;
  public mandatory_skills: string[] | string;
  public schools: string[] | string;
  public mandatory_schools: string[] | string;
  public locations: string[];
  public mandatory_locations: string[] | string;
  public company_sizes: string[] | string;
  public mandatory_company_sizes: string[] | string;
  public companies: string[] | string;
  public mandatory_companies: string[] | string;
  public industries: string[] | string;
  public mandatory_industries: string[] | string;
  public degrees: string[] | string;
  public mandatory_degrees: string[] | string;
  public education_majors: string[] | string;
  public mandatory_education_majors: string[] | string;
  public fromYrsOfExperience: number;
  public toYrsOfExperience: number;

  constructor() {
      this.job_titles = [];
      this.mandatory_job_titles = [];
      this.skills = [];
      this.mandatory_skills = [];
      this.schools = [];
      this.mandatory_schools = [];
      this.locations = [];
      this.mandatory_locations = [];
      this.companies = [];
      this.mandatory_companies = [];
      // this.company_sizes = [];
      // this.mandatory_company_sizes = [];
      // this.companies = [];
      // this.mandatory_companies = [];
      // this.industries = [];
      // this.mandatory_industries = [];
      // this.degrees = [];
      // this.mandatory_degrees = [];
      // this.education_majors = [];
      // this.mandatory_education_majors = [];

  }
}

export class mandatoryFreemiumJDKeys{
  public jobtitle: { key: string; isMandatory: boolean }[];
  public company: { key: string; isMandatory: boolean }[];
  public skills: { key: string; isMandatory: boolean }[];
  public location: { key: string; isMandatory: boolean }[];
  public degree: string[] | string;
  public school: string[] | string;
  public companysize: string[] | string;
  public fieldofstudy:  string[] | string;
  public industries: string[] | string;
  public fromYrsOfExperience: number;
  public toYrsOfExperience: number;
  public locationcontinent: string | null;


  constructor() {
    this.jobtitle = [];
    this.company = [];
    this.skills = [];
    this.location = [];
    this.degree = [];
    this.school = [];
    this.companysize = [];
    this.fieldofstudy = [];
    this.industries = [];
    this.locationcontinent = null;
  }

}
